import React, { Component } from 'react';
import { css } from 'aphrodite/no-important';
import styles from '../checkboxcontrol/CheckboxControl.styles';

class CheckboxControl extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isChecked: props.isChecked
    };
  }
  render() {
    const isChecked = this.props.isChecked;
    return isChecked === 'true' ? (
      <p className={css(styles.check, styles.truecheck)}>&#10004;</p>
    ) : (
      <p className={css(styles.check, styles.falsecheck)}>&#10006;</p>
    );
  }
}

export default CheckboxControl;



// WEBPACK FOOTER //
// ./src/components/inputs/checkboxcontrol/CheckboxControl.js